module.exports = __webpack_public_path__ + "static/img/mulan_xiaohongshu.9fe5fc93.png";